import apiClient from "../clinet";

// Create new comment
const createComment = async ({
  category,
  data,
}: {
  category: string;
  data: any;
}) => {
  const endpoint = category === "posts" ? "/postsComments" : "/galleryComments";
  const response = await apiClient.post(endpoint, data);
  return response.data;
};

const getContentComments = async (
  category: string,
  contentId: string | number
) => {
  const endpoint =
    category === "posts"
      ? `/postsComments/${contentId}`
      : `/galleryComments/${contentId}`;
  const response = await apiClient.get(endpoint);
  return response.data;
};

export default {
  createComment,
  getContentComments,
};
